/* ==========================================================================
   frd-motion.js — 只在板块进入视口时播放动画（海鸥飞行 / 灯塔扫光 / 气泡）
   动画本身全在 CSS 里，这里只负责给元素挂 .frd-live 开关，省电 + 避免
   在首屏外白跑。prefers-reduced-motion 时直接不挂，CSS 侧也另有兜底。
   ========================================================================== */
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init() {
    const targets = document.querySelectorAll('.frd-anim');
    if (!targets.length) return;

    if (reduced.matches || !('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add('frd-live'));
      return;
    }

    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('frd-live', entry.isIntersecting);
      });
    }, { rootMargin: '120px 0px', threshold: 0 });

    targets.forEach((el) => io.observe(el));

    // 主题编辑器里重新加载板块时要重新接管
    document.addEventListener('shopify:section:load', () => {
      document.querySelectorAll('.frd-anim:not(.frd-live-bound)').forEach((el) => {
        el.classList.add('frd-live-bound');
        io.observe(el);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
